import { render, staticRenderFns } from "./CreateNewCustomerModal.vue?vue&type=template&id=d1293db8"
import script from "./CreateNewCustomerModal.vue?vue&type=script&lang=js"
export * from "./CreateNewCustomerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports